import React, { useState } from 'react';
import { Polygon as GPolygon } from 'react-google-maps';
import { compose, setDisplayName, UnpackICEWP, withHandlers, withState } from 'recompose';
import { createSelector } from 'reselect';
import * as wicket from 'wicket';
import { IMapShapeProps } from '../types';
const Wkt = wicket.Wkt;

export const serialize = (polygon: google.maps.Polygon[]) => {
  const wkt = new Wkt();
  wkt.fromObject(polygon);
  return wkt.write();
};
export const parse = (wellKnownText: string) => {
  const wkt = new Wkt();
  // wkt.read('MULTIPOLYGON (((40 40, 20 45, 45 30, 40 40)), ((20 35, 10 30, 10 10, 30 5, 45 20, 20 35), (30 20, 20 15, 20 25, 30 20)))')
  wkt.read(wellKnownText);
  return wkt.toObject() as google.maps.Polygon[];
};
export const isEqual = (a: google.maps.Polygon, b: google.maps.Polygon) => {
  if (a.getPaths().getLength() !== b.getPaths().getLength()) {
    return false;
  }
  return a
    .getPaths()
    .getArray()
    .every((mvca, mvcaIdx) => {
      if (
        mvca.getArray().length !==
        b
          .getPaths()
          .getAt(mvcaIdx)
          .getArray().length
      ) {
        return false;
      }
      return mvca.getArray().every((l, i) =>
        l.equals(
          b
            .getPaths()
            .getAt(mvcaIdx)
            .getAt(i)
        )
      );
    });
};

const createCoordinatesSelector = () => {
  return createSelector([(props: IMapShapeProps) => props.zone], (zone) => {
    try {
      return {
        features: parse(zone.WellKnownText as string), // !!!MUTABLE!!!
        initFeatures: zone.wkt.toObject() as google.maps.Polygon[],
      };
    } catch (error) {
      console.error(error);
      return {
        features: [],
        initFeatures: [],
      };
    }
  });
};

const useDirtyState = withState('dirty', 'setdirty', false);

const handlers = () => {
  const optionsSelector = createCoordinatesSelector();
  return {
    getCoordinates: (props: IMapShapeProps) => () => {
      return optionsSelector(props);
    },
  };
};
const useHandlers = withHandlers(handlers);
type Handlers = UnpackICEWP<typeof useHandlers>;

interface IInjectedProps extends IMapShapeProps, UnpackICEWP<typeof useDirtyState> {}

const MultiPolygon = compose<IInjectedProps & Handlers, IMapShapeProps>(
  setDisplayName('MultiPolygon'),
  useDirtyState,
  useHandlers
)(({ zone, getCoordinates, onChange, onSelect, disabled }) => {
  const { features: initialFeatures, initFeatures } = getCoordinates();
  const [features] = useState(initialFeatures);

  return (
    <>
      {features.map((polygon, idx) => {
        const polyRef = React.createRef<GPolygon>();

        return (
          <GPolygon
            ref={polyRef}
            key={(zone.Id as number) + '.' + idx}
            onClick={disabled ? undefined : onSelect}
            onMouseUp={
              disabled
                ? undefined
                : () => {
                    if (polyRef && polyRef.current) {
                      if (!isEqual(polygon, initFeatures[idx])) {
                        onChange(serialize(features));
                      }
                    }
                  }
            }
            paths={polygon.getPaths()}
            options={zone.options}
          />
        );
      })}
    </>
  );
});

export default MultiPolygon;
